<template>
    <div>
        <div class="">
            <SearchBarPower/>
        </div>
        <Word :word="currentWordLookup" v-if="currentWordLookup"/>

    </div>
</template>

<script>
    import Word from "@/components/dictionary/oxford/Word"
    import SearchBarPower from "@/components/dictionary/search/SearchBarPower"

    export default {
        name: 'LookupPower',
        components: {
            Word, SearchBarPower
        },
        props: {},
        data: function () {
            return {}
        },
        mounted() {
            // this.wordText = this.$route.query['word']
        },
        computed: {
            currentWordLookup() {
                // console.log('currentWordLookup change', this.$store.getters.currentWordLookup)
                return this.$store.getters.currentWordLookup
            }
        }
    }
</script>
